import "@/styles/vendor.css";
import "@/styles/index.css";

import form from "@/scripts/components/form/form";
import mediaSlider from "@/scripts/components/media-slider";
import modal from "@/scripts/components/modal";
import paginatedList from "@/scripts/components/paginated-list";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import slideToggle from "@/scripts/components/slide-toggle";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

form.init();
mediaSlider.init();
modal.init();
paginatedList.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
slideToggle.init();

Alpine.plugin(focus);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});

/**
 * Workaround for no safelist
 * class="opacity-50 bg-[#f8f6f1]"
 */
